import { capitalize, map } from 'es-toolkit/compat';
import keyMirror from 'keymirror';

const TableViewConstants = keyMirror({
  AERIAL: null,
  LIST: null,
});

export const TableViewOptions = map(TableViewConstants, (tableView: string) => {
  return {
    key: tableView,
    label: capitalize(tableView),
    value: tableView,
  };
});

export default TableViewConstants;
